import axios from "axios";
import { apiUrl } from "../config";
import authenticationStore from "../store/authenticationStore";
import { requests } from "./DefaultRequest";

export const CompanyRequest = {
    getCompanyList: (params) =>
        axios({
            method: "get",
            url: `${apiUrl}/api/v1/companies`,
            headers: {
                Authorization: `Bearer ${
                    JSON.parse(authenticationStore.appToken).access_token
                }`,
                "Content-Type": "application/json",
            },
            params: params || {
                status: true,
            },
        }),
    getCompanyDetail: (code) => requests.get(`/api/v1/companies/${code}`),

    createCompany: (payload) =>
        requests.post(`/api/v1/companies/departments`, payload),

    updateCompany: (code, payload) =>
        requests.put(`/api/v1/companies/${code}`, payload),

    updateCompanyStatus: (code, payload) =>
        requests.patch(`/api/v1/companies/${code}`, payload),

    deleteCompany: (code) => requests.delete(`/api/v1/companies/${code}`),

    getUserListWithRole: (role_name, company_code) =>
        axios({
            method: "get",
            url: `${apiUrl}/api/v1/companies/${company_code}/users`,
            headers: {
                Authorization: `Bearer ${
                    JSON.parse(authenticationStore.appToken).access_token
                }`,
                "Content-Type": "application/json",
            },
            params: {
                code: company_code,
                role_name: role_name,
            },
        }),
};
